// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PostInspectionHomePageQueryOverViewBody,
    BaseResponseHomePageOverviewResponse,
} from '../../types';

/**
 * queryOverView
 *
 * @export
 * @tags inspection-home-page-controller
 * @link [POST] /inspectionHomePage/queryOverView
 */
export function postInspectionHomePageQueryOverView(
    data: PostInspectionHomePageQueryOverViewBody
): Promise<BaseResponseHomePageOverviewResponse>;
export function postInspectionHomePageQueryOverView(
    data: PostInspectionHomePageQueryOverViewBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseHomePageOverviewResponse>;
export function postInspectionHomePageQueryOverView(
    data: PostInspectionHomePageQueryOverViewBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseHomePageOverviewResponse> {
    return request<PostInspectionHomePageQueryOverViewBody, never, never>(
        '/inspectionHomePage/queryOverView',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postInspectionHomePageQueryOverView',
        }
    );
}

export const meta = [
    {
        tags: ['inspection-home-page-controller'],
        path: '/inspectionHomePage/queryOverView',
        method: 'post',
    },
];
